import { getGetIsFeatureAvailable } from 'features/features/store/selectors';
import { useAppSelector } from 'store/hooks';

export const useIsFlashScoreEnabled = () => useAppSelector(getGetIsFeatureAvailable)('flashScore');
